import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const StyledMainContainer = styled(Box)`
    height: 100%;
    overflow: hidden;
`;
